const ITEMS = [
  "Custom Software",
  "Web Applications",
  "SaaS Platforms",
  "Workflow Automation",
  "System Integrations",
  "Dashboards & Analytics",
  "AI-Powered Solutions",
  "Tacoma, WA — Serving Businesses Everywhere",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div
      className="relative overflow-hidden border-y border-slate-800/70 bg-navy/60 py-5"
      data-testid="editorial-marquee"
      aria-hidden="true"
    >
      <div className="flex w-max animate-marquee items-center gap-10 whitespace-nowrap">
        {row.map((item, i) => (
          <span key={i} className="flex items-center gap-10">
            <span className="font-display text-sm font-medium uppercase tracking-[0.3em] text-slate-400">
              {item}
            </span>
            <span className="h-1.5 w-1.5 rounded-full bg-blue-500/60" />
          </span>
        ))}
      </div>
      <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-void to-transparent" />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-void to-transparent" />
    </div>
  );
}
